import { Accordion } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const ReviewAndConfirm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const ReviewBoxWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: 30vh;
`;

const ReviewBox = styled.div`
  background: var(--color-bg-body);
  border-radius: var(--size-border-radius-lg);
  margin: 0 auto;
  padding: 4px 12px;
  width: 400px;
`;

const ReviewBoxKey = styled.div`
  font-size: 18px;
  line-height: 150%;
  width: 200px;
`;

const ReviewBoxValue = styled.div`
  font-size: 18px;
`;

const ReviewBoxRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  padding: 8px;
  padding-right: 14px;

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: var(--color-info-weakest);
      border: 1px solid var(--color-info-weaker);
      border-radius: var(--radius-m);
      margin: 0 -8px;
      padding-right: 20px;
    `}
`;

const ReviewAccordion = styled(Accordion)`
  ${Accordion.S.AccordionBody} {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    padding-top: 0;
  }
`;

const Value = styled.div`
  color: var(--color-neutral-800);
  font-weight: 700;
  min-width: fit-content;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export {
  ReviewAccordion,
  ReviewAndConfirm,
  ReviewBox,
  ReviewBoxKey,
  ReviewBoxRow,
  ReviewBoxValue,
  ReviewBoxWrapper,
  Row,
  Value
};
